import React from 'react';
import { Paper } from '@material-ui/core';

// Rising / falling products: change in scans vs the equal-length prior window.
// Momentum is more actionable than raw rank — it flags what to feature now and
// what's cooling off. Click an item to open the product.
const List = ({ title, items, direction }) => (
  <div className="insights__momentum-col">
    <h4 className={direction === 'up' ? 'insights__delta-up' : 'insights__delta-down'}>
      {title}
    </h4>
    {items.length === 0 ? (
      <div className="insights__card-sub">No movement.</div>
    ) : (
      items.map((m) => (
        <div
          className="insights__momentum-item"
          key={m.product_uuid}
          onClick={() => window.open(`/product/${m.product_uuid}`, '_blank')}
          style={{ cursor: 'pointer' }}
        >
          <span>
            {m.trade_name}
            <span className="insights__card-sub"> · {m.manufacturer_name}</span>
          </span>
          <span className={direction === 'up' ? 'insights__delta-up' : 'insights__delta-down'}>
            {m.delta > 0 ? '+' : ''}
            {m.delta}
          </span>
        </div>
      ))
    )}
  </div>
);

const Momentum = ({ momentum }) => {
  const rising = momentum?.rising || [];
  const falling = momentum?.falling || [];
  return (
    <Paper className="insights__card insights__col-6" variant="outlined">
      <div className="insights__card-head">
        <span className="insights__card-title">Momentum</span>
        <span className="insights__card-sub">scan change vs prior period</span>
      </div>
      <div
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}
      >
        <List title="▲ Rising" items={rising} direction="up" />
        <List title="▼ Falling" items={falling} direction="down" />
      </div>
    </Paper>
  );
};

export default Momentum;
